import React from 'react';
import { Box, Flex, TextV2 as Text, InputV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { FilterFacet } from './FilterFacet';
import { StyledSlider, PriceFilterSkeleton } from '../components';
import { useTranslation } from '@shared/core';
import { SkeletonGroup } from '@shared/components/Skeleton';
import { PriceDistributionChart } from './PriceDistributionChart';
import { PRICE_RANGE } from '../../../constants';

interface PriceRangeFacetProps {
  title: string;
  description: string;
  priceRange: [number, number];
  onPriceRangeChange: (value: number | readonly number[]) => void;
  isLoading?: boolean;
  prices?: number[]; // Array of all prices to show in distribution
}

export const PriceRangeFacet: React.FC<PriceRangeFacetProps> = ({ title, description, priceRange, onPriceRangeChange, isLoading, prices = [] }) => {
  const { t } = useTranslation('accommodationsConsole');
  const filterPanelTrans = t('filterPanel');

  return (
    <SkeletonGroup isReady={!isLoading} placeholder={<PriceFilterSkeleton />}>
      <Box maxWidth={{ _: pxToRem(222), sm: 'full' }}>
        <FilterFacet title={title} description={description}>
          <Box marginBottom={pxToRem(-12)}>
            <PriceDistributionChart prices={prices} />
          </Box>
          <StyledSlider
            value={priceRange}
            onChange={onPriceRangeChange}
            min={PRICE_RANGE.MIN}
            max={PRICE_RANGE.MAX}
            className="slider"
            trackClassName="track"
            thumbClassName="thumb"
          />
          <Flex gap={3} alignItems="center" marginTop={7}>
            <Box>
              <Text typographyVariant="label3" marginBottom={3}>
                {filterPanelTrans.priceRange.min()}
              </Text>
              <InputV2
                type="number"
                value={priceRange[0]}
                onChange={e => onPriceRangeChange([parseInt(e.target.value, 10) || 0, priceRange[1]])}
                placeholder="Min"
                startElement={<Text typographyVariant="body2">$</Text>}
                style={{ paddingLeft: pxToRem(32) }}
                min={0}
              />
            </Box>
            <Text marginTop={pxToRem(24)}>-</Text>
            <Box>
              <Text typographyVariant="label3" marginBottom={3}>
                {filterPanelTrans.priceRange.max()}
              </Text>
              <InputV2
                type="number"
                value={priceRange[1]}
                onChange={e => onPriceRangeChange([priceRange[0], parseInt(e.target.value, 10) || 3500])}
                placeholder="Max"
                startElement={<Text typographyVariant="body2">$</Text>}
                style={{ paddingLeft: pxToRem(32) }}
                min={0}
              />
            </Box>
          </Flex>
        </FilterFacet>
      </Box>
    </SkeletonGroup>
  );
};
